import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";

// Main Component
const ThankYou = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#0A1929",
        color: "white",
        display: "flex",
        alignItems: "center",     // Vertical center
        justifyContent: "center", // Horizontal center
        textAlign: "center",
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Thank You!
        </Typography>
        <Typography variant="body1">
          We look forward to speaking with you soon.
        </Typography>
       
        <Button 
        sx={{
          mt: 2,
        }}
        variant="contained" color="primary" onClick={() => window.location.href = '/'}>
          Back to Home
        </Button>
      </Container>
    </Box>
  );
};

export default ThankYou;
